module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.4618f0de.ttf";